import React, { Fragment } from 'react';

export default (option) => (
  <Fragment>
    <i className={option.icon} /><span className="ui-autocomplete-text">{option.label}</span>
  </Fragment>
);
